export const isValidTimezone = (
  timezone = '',
  availableTimezones: string[] = []
) => {
  if (!timezone) {
    return false;
  }

  return availableTimezones.includes(timezone);
};
